import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PanelmenuComponent } from './panelmenu.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: PanelmenuComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class PanelmenuRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/panelmenu/panelmenu-routing.module.ts